<script setup lang="ts">
withDefaults(defineProps<{
  showLabel?: boolean,
  label?: string,
  labelClass?: string,
  position?: "left" | "right",
}>(), {
  label: "",
  showLabel: true,
  position: "left",
});
</script>

<template>

<div
  class="flex flex-col justify-end"
  :class="[
    position === 'left' ? 'items-start' : 'items-end',
  ]">
  <span
    v-if="showLabel"
    class="w-full uppercase text-xs leading-3 mb-1 text-gray-500 !font-medium dark:text-gray-300 dark:font-semibold"
    :class="[
      labelClass,
    ]">
    <slot name="label">{{ label }}</slot>
  </span>
  <slot />
</div>

</template>
